export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6234.de42d03f.jpg";